<template>
    <div class="box-container">
        <div id="home-section-six" class="container-size-fixer">
            <div class="row" style="padding-top: 50px">
                <div class="section-six-main-child col-lg-8" style="padding: 0">
                    <div id="text-content">
                        <div id="title">
                            اپلیکیشن
                            <span style="color: rgb(204, 23, 29)">کانادا از ایران</span>
                        </div>
                        <div id="description" v-if="explain">
                            {{explain}}
                        </div>
                        <div v-if="homeLoadingMood">
                            <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
                        </div>
                        <a class="btn-hover" @click.prevent="$router.push('/application-page')">
                            دانلود اپلیکیشن
                        </a>
                    </div>
                </div>
                <div class="section-six-main-child  col-lg-4">
                    <img width="392" height="360"
                         src="../assets/appIcons/Pics/CanadaAzIran/Pics/Firebase-vs-XMPP-Chat-App-Development-1568x1045.png"
                         alt="">
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "HomeSectionSix",
        props:['explain','homeLoadingMood'],
    }
</script>

<style scoped lang="scss">
    .box-container{
        overflow: hidden;
    }
    a{
    cursor: pointer;
    }


    /*#home-section-six > .row {*/
        /*padding-top: 50px;*/
    /*}*/

    #space {
        width: 100%;
        height: 10px;
        background-color: #162336;
    }

    #text-content {
        margin-top: -150px !important;
        width: auto;
        height: auto;
        z-index: 200;
    }

    #title {
        width: 95%;
        height: 57px;
        font-family: IRANSans;
        font-size: 26px;
        /*font-size: min(max(36px, 4vw), 26px);*/

        /*font-size: min(4vw, 36px);*/
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
        margin-top: 160px;
        float: right;
    }

    #description {
        width: 95%;
        height: 77px;
        margin-top: 30px;
        font-family: 'IRANSans';
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
        float: right;
    }

    a {
        width: 369px;
        height: 54px;
        padding: 15px 108px;
        border-radius: 10px;
        background-color: #162336;
        float: right;
        color: white !important;
        margin-top: 30px;
    }


    #home-section-six {
        margin-top: 10px;
    }

    .section-six-main-child {
        min-height: 357px;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../assets/appIcons/Pics/canadaMap.png");
    }

    .section-six-main-child:nth-child(1) > img {
        z-index: -5;
        position: absolute;
        bottom: 0;
        top: 0;
        right: 0;
        height: 100%;
        width: auto;
    }

    .section-six-main-child:nth-child(1) {

    }

    #home-section-six {
        margin: 10px auto 0 auto;
        background-color: white;
    }

    @media (max-width: 1300px) {
        #text-content {
            margin-right: 15px;

        }
        #home-section-six {
            padding: 15px;
        }
        a {
            width: 80%;
            padding: 10px 0;
        }
        #img-content {
            width: 95%;
        }
    }

    @media (max-width: 992px) {
        .section-six-main-child:nth-child(2) {
            display: none;
        }
    }
</style>